<script lang="ts">
	import { onMount, createEventDispatcher } from "svelte";
	import { slide } from "svelte/transition";
	import { serpPageConfigStores } from "../../../stores/stores.serpPage";
	import { FilterStores } from "../../../../types/types.serpPage";
	import { Icon } from "../../../../generic/components";
	import RangeSlider from "../../../../libs/svelte-range-slider-pips-main";

	export let filter: FilterStores;

	let minPossibilityPrice: number = 0;
	let maxPossibilityPrice: number = 0;
	let show: boolean = false;
	let isClosed: boolean = false;
	let isEmpty: boolean = false;
	let prices: number[] = [minPossibilityPrice, maxPossibilityPrice];
	const dispatch = createEventDispatcher();

	$: {
		const { currentValueSelected = [] } = filter;
		if (currentValueSelected.length == 0) {
			calculateValues();
		}
	}

	onMount(() => {
		isClosed = $serpPageConfigStores.isFilterCloseOnStart ?? false;
		isEmpty = filter.currentValueSelected?.length == 0;
		if (isEmpty) {
			show = !isClosed && !isEmpty;
		}
		calculateValues();
	});

	function calculateValues() {
		const { currentValues, currentValueSelected = [] } = filter;
		let min: number = 0;
		let max: number = 0;
		if (currentValueSelected.length) {
			min = parseFloat(currentValueSelected[0]);
			max = parseFloat(currentValueSelected[1]);
		} else {
			currentValues.forEach(({ name }) => {
				const value: number = parseFloat(name);
				min = Math.min(min, value);
				max = Math.max(max, value);
			});
		}
		minPossibilityPrice = parseFloat(min.toFixed(2));
		maxPossibilityPrice = parseFloat(max.toFixed(2));
		prices = [minPossibilityPrice, maxPossibilityPrice];
	}

	function toogleCollapse() {
		show = !show;
	}

	function valueChanged() {
		dispatch("valueChanged", {
			value: prices,
			filter: filter,
		});
	}
</script>

{#if minPossibilityPrice > 0 || maxPossibilityPrice > 0}
	<button class="sidebarCollapseButton bsCollapse" class:collapsed={!show} on:click={toogleCollapse} type="button" title="" aria-expanded={show}>
		{filter.name}
		<Icon template="ic-arrow-down" styleClass="bsCollapseIcon" />
	</button>
	{#if show}
		<div class="px-3 py-2 border-top" transition:slide={{ duration: 400 }}>
			<RangeSlider range pushy float step={0.01} bind:values={prices} min={minPossibilityPrice} max={maxPossibilityPrice} on:change={valueChanged} />
			<div class="rangeInputs">
				<input type="number" class="controlFreeNumberInput" step={0.01} min={minPossibilityPrice} max={maxPossibilityPrice} on:change={valueChanged} bind:value={prices[0]} />
				<input type="number" class="controlFreeNumberInput" step={0.01} min={minPossibilityPrice} max={maxPossibilityPrice} on:change={valueChanged} bind:value={prices[1]} />
			</div>
		</div>
	{/if}
{/if}
